import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import Constants from "../frontLayout/Variables/Constants";
import logo from "../assets/images/logo.png";
import LoginComponent from "./LoginComponent";
import SignupComponent from "./SignupComponent";

const LoginModal = ({ isOpen, setIsOpen, actionPerform }) => {

    const [showLogin, setShowLogin] = useState(true);

    return (
        <Modal show={isOpen} onHide={() => setIsOpen(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Instant Login</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <NavLink to="/" className="navbar-brand">
                    <img loading="lazy"  src={logo} alt="Logo" />
                </NavLink>
                {showLogin === true ? (<>
                    <LoginComponent
                        setIsOpen={setIsOpen}
                        setShowLogin={setShowLogin}
                        actionPerform={actionPerform}
                    />
                </>) : (<>
                    <SignupComponent
                        setIsOpen={setIsOpen}
                        setShowLogin={setShowLogin}
                        actionPerform={actionPerform}
                    />
                </>)}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setIsOpen(false)}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default LoginModal